<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：设置-配送设置-基础设置
      -->
  <div class="product-add" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <div class="common-form">配送方式</div>
      <el-form-item label="是否开启快递配送: " prop="is_express" v-auth="'/setting/distribution/dialog/setting/express'">
        <el-radio-group v-model="form.is_express">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启上门自提: " prop="is_extract" v-auth="'/setting/distribution/dialog/setting/extract'">
        <el-radio-group v-model="form.is_extract">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启无需物流: " prop="is_no_express" v-auth="'/setting/distribution/dialog/setting/no_express'">
       <el-radio-group v-model="form.is_no_express">
         <el-radio :label="1">开启</el-radio>
         <el-radio :label="0">关闭</el-radio>
       </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启礼品仓进货: " prop="is_warehouse" v-auth="'/warehouse/setting/index'">
        <el-radio-group v-model="form.is_warehouse">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启配送: " prop="is_distribution" v-auth="'/setting/distribution/dialog/distribution'">
        <el-radio-group v-model="form.is_distribution">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启自提: " prop="is_in_store" v-auth="'/setting/distribution/dialog/extract'">
        <el-radio-group v-model="form.is_in_store">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="common-form" v-if="form.is_extract == 1"  v-auth="'/setting/distribution/dialog/setting/extract/store_delivery'">上门自提</div>
      <el-form-item label="是否开启门店配送: " prop="is_store_delivery"  v-if="form.is_extract == 1" v-auth="'/setting/distribution/dialog/setting/extract/store_delivery'">
        <el-radio-group v-model="form.is_store_delivery">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--提交-->
      <div style="height: 100px;"></div>
      <div class="common-button-wrapper">
         <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </div>
    </el-form>

  </div>
</template>
<script>
  import SettingApi from '@/api/setting.js';
  export default {
    data() {
      return {
        form: {
          is_express: 0,
          is_extract: 0,
          is_no_express: 0,
          is_warehouse: 0,
          is_distribution: 0,
          is_in_store: 0,
          is_store_delivery: 0,
        },
        /*是否正在加载*/
        loading: true,


      };
    },
    created() {
      /*获取列表*/
      this.getSetting();
    },
    methods: {
      /*获取设置*/
      getSetting() {
        let self = this;
        let Params = {};
        SettingApi.getDeliverySetting(Params, true)
          .then(data => {
            self.form = data.data.delivery;
            self.loading = false;
          })
          .catch(error => {});
      },
      /*点击保存*/
      onSubmit() {
        let self = this;
        let params = self.form;
        self.loading = true;
        SettingApi.editDeliverySetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getSetting();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/setting/distribution/dialog/setting.vue